export const serviceVersion = import.meta.env.VITE_OTEL_SERVICE_VERSION || '0.0.0';
